import React from "react";
import Button from "@mui/material/Button";
import GetAppIcon from "@mui/icons-material/GetApp";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { GitHub, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  const downloadPdf = () => {
    const pdfUrl =
      "https://portfolio-server-1fm2.onrender.com/Maia-Kiknavelidze-Resume.pdf";

    const a = document.createElement("a");
    a.href = pdfUrl;
    a.target = "_blank";
    a.download = "Maia-Kiknavelidze-Resume.pdf";

    a.click();

    a.remove();
  };

  const footerStyle = {
    width: "97%",
    marginLeft: "1%",
  };

  const buttonStyle = {
    width: "100%",
    margin: "5px",
    padding: "15px",
    fontSize: "20px",
    borderRadius: "8px",
    color: "white",
    fontWeight: "bold",
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer style={footerStyle}>
      <Button
        variant="contained"
        sx={{
          ...buttonStyle,
          background: "linear-gradient(to right, blue, purple)",
          "&:hover": {
            background: "linear-gradient(to right, purple, blue)",
          },
        }}
        onClick={scrollToTop}
      >
        <ArrowUpwardIcon />
      </Button>

      <Button
        variant="contained"
        sx={{
          ...buttonStyle,
          background: "linear-gradient(to right, purple, blue)",
          "&:hover": {
            background: "linear-gradient(to right, blue, purple)",
          },
        }}
        onClick={downloadPdf}
      >
        <GetAppIcon /> Download Resume
      </Button>

      <Button
        variant="contained"
        href="/coverletter"
        sx={{
          ...buttonStyle,
          background: "linear-gradient(to right, blue, purple)",
          "&:hover": {
            background: "linear-gradient(to right, purple, blue)",
          },
        }}
      >
        Why Work With Me?
      </Button>
      <Button
        variant="contained"
        href="https://github.com/slunecnicee"
        target="blank"
        sx={{
          ...buttonStyle,
          background: "linear-gradient(to right, blue, purple)",
          "&:hover": {
            background: "linear-gradient(to right, purple, blue)",
          },
        }}
      >
        <GitHub fontSize="large" />
        View Github
      </Button>
      <Button
        variant="contained"
        href="https://www.linkedin.com/in/maia-kiknavelidze-459864253/"
        target="blank"
        sx={{
          ...buttonStyle,
          background: "linear-gradient(to right, blue, purple)",
          "&:hover": {
            background: "linear-gradient(to right, purple, blue)",
          },
        }}
      >
        <LinkedIn fontSize="large" />
        View LinkedIn
      </Button>
    </footer>
  );
};

export default Footer;
